export const inbox = {
  titles: {
    inbox: "Posteingang",
    unifiedInbox: "Ihr Posteingang, vereint",
  },
  subtitles: {
    manageMessages: "Verwalten Sie Nachrichten aus Ihren Buchungskanälen",
    unifiedDesc:
      "Hier sehen Sie alle Konversationen mit Ihren Gästen, unabhängig davon, ob sie über Airbnb, Booking oder einen anderen Kanal schreiben.",
    subscribeHint:
      "Abonnieren Sie, um Ihren Posteingang zu aktivieren und Ihre Kommunikation zu vereinfachen.",
    planOnly:
      "Dieses Modul ist nur in den Tarifen {plans} verfügbar.",
  },
  states: {
    notInstalledTitle: "Nachrichtenmodul nicht installiert",
    notInstalledDesc:
      "Installieren Sie das Nachrichtenmodul, um sich mit Ihren Buchungskanälen zu verbinden.",
    noChannelsTitle: "Keine Kanäle verbunden",
    noChannelsDesc:
      "Um das Nachrichtenmodul zu nutzen, muss mindestens ein Kanal verbunden sein (Booking.com, Airbnb).",
    noAccessTitle: "Sie haben keinen Zugriff auf das Nachrichtenmodul",
  },
  actions: {
    installModule: "Nachrichtenmodul installieren",
    configureChannel: "Kanal konfigurieren",
  },
  toasts: {
    connectChannelRequiredTitle: "Verbindung erforderlich",
    connectChannelRequiredBody:
      "Verbinden Sie mindestens einen Buchungskanal, um das Nachrichtenmodul zu installieren.",
  },
  errors: {
    notFoundPropertyOrUser: "Unterkunft oder Benutzer nicht gefunden.",
    channelConnectGeneric:
      "Fehler beim Verbinden mit dem Kanal. Bitte versuchen Sie es erneut.",
    generateTokenError: "Fehler beim Erstellen des Tokens",
  },
};
